export const RESOURCE_TYPE_USER_HOMEPAGE = 'USER_HOMEPAGE';
